// 监控来源的工程同步状态只用于判断；面向商户统一描述业务对象与已获取的部分动态。
export function isMonitorCard(type: string): type is "competitor_updates" | "creator_tracking" {
  return type === "competitor_updates" || type === "creator_tracking";
}
export function monitorCardSummary(type: string, state: string, summary: string, objectCount?: number) {
  if (!isMonitorCard(type) || state !== "ready") return summary;
  const object = type === "competitor_updates" ? "竞品" : "达人";
  return objectCount === undefined ? `查看已关注${object}的近期动态。` : `已关注 ${objectCount} 个${object}，查看近期动态。`;
}
export function monitorActivity(count: number | null, windowHours = 24) {
  return { label: `近${windowHours}小时已获取动态（部分）`, value: count === null ? "暂无可靠数量" : `${count} 条` };
}
export function monitorStateLabel(state: string) {
  switch (state.toUpperCase()) {
    case "ACTIVE": return "监控中";
    case "PAUSED": return "已暂停";
    case "CANCELLED":
    case "CANCELED": return "已取消";
    case "FAILED": return "同步失败";
    default: return "状态待确认";
  }
}
